import '.d{display:flex;}.ssr-plugin'
import '.y{align-items:center;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { styled } from 'inlines'
import { RadioButton } from './RadioButton'
import { useId } from 'react'

export type RadioButtonGroupOption<T extends string> = {
  value: T
  label?: string
  tooltipText?: string
}

export type RadioButtonGroupProps<T extends string> = {
  selectedOption?: T
  options: RadioButtonGroupOption<T>[]
  name?: string
  labelPosition?: 'left' | 'right'
  labelSize?: 'medium' | 'small'
  disabled?: boolean
  style?: React.CSSProperties
  radioButtonStyle?: React.CSSProperties
  onClick: (option: T) => void
}

export const RadioButtonGroup = <T extends string>({
  selectedOption,
  options,
  name,
  labelPosition = 'right',
  labelSize = 'medium',
  disabled = false,
  style,
  radioButtonStyle,
  onClick,
}: RadioButtonGroupProps<T>) => {
  const id = useId()
  const groupName = name ?? `${id}-group`
  return (
    <styled.div className="d y g"
      style={{
        ...style,
      }}
    >
      {options.map((option) => (
        <RadioButton
          key={option.value}
          disabled={disabled}
          groupName={groupName}
          label={option.label}
          labelPosition={labelPosition}
          labelSize={labelSize}
          selected={selectedOption === option.value}
          style={radioButtonStyle}
          onClick={() => onClick(option.value)}
          tooltipText={option.tooltipText}
        />
      ))}
    </styled.div>
  )
}
